import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "card-title align-items-start flex-column" }
const _hoisted_4 = { class: "card-label fw-bolder text-dark" }
const _hoisted_5 = { class: "card-body p-0" }
const _hoisted_6 = { class: "card-px" }
const _hoisted_7 = { class: "row g-5 g-xl-8" }
const _hoisted_8 = { class: "col-xl-5" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", { class: "col-sm-5 col-form-label fw-bold fs-6 required" }, "Transfer Type", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Select transfer type")
const _hoisted_11 = /*#__PURE__*/_createVNode("label", { class: "col-sm-5 col-form-label fw-bold fs-6 required" }, "Source Account Number", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Select source account")
const _hoisted_13 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_14 = /*#__PURE__*/_createVNode("label", { class: "col-sm-5 col-form-label fw-bold fs-6 required" }, "Destination Account Number", -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Select destination account number")
const _hoisted_16 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_17 = { class: "d-flex justify-content-end mt-2" }
const _hoisted_18 = /*#__PURE__*/_createVNode("label", { class: "col-sm-5 col-form-label fw-bold fs-6 required" }, "Amount", -1)
const _hoisted_19 = {
  key: 0,
  class: "text-muted fs-6"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("label", { class: "col-sm-5 col-form-label fw-bold fs-6" }, "Description", -1)
const _hoisted_21 = { class: "card-footer d-flex justify-content-end py-6" }
const _hoisted_22 = /*#__PURE__*/_createVNode("button", {
  type: "reset",
  class: "btn btn-white btn-active-light-primary me-2"
}, " Reset ", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("span", { class: "indicator-label" }, " Submit ", -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode()
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_29 = { class: "dialog-footer" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Confirm ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")
  const _component_el_descriptions = _resolveComponent("el-descriptions")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_form = _resolveComponent("el-form")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("section", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("h3", _hoisted_3, [
          _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("finance.overbooking.title")), 1)
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_el_form, {
            id: "overbooking_form",
            model: _ctx.overbooking,
            ref: "formRef",
            class: "form"
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        size: "small",
                        modelValue: _ctx.overbooking.transfer_type,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.overbooking.transfer_type = $event)),
                        loading: _ctx.isValidatingType,
                        placeholder: "Please select transfer type",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, { value: "" }, {
                            default: _withCtx(() => [
                              _hoisted_10
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.transferType, (key, value) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: key,
                              label: key,
                              value: value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "loading"])
                    ]),
                    _: 1
                  }),
                  _hoisted_11,
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        size: "small",
                        modelValue: _ctx.overbooking.source_account,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.overbooking.source_account = $event)),
                        loading: _ctx.isValidatingSource,
                        placeholder: "Please select source account number",
                        style: {"width":"100%"},
                        onChange: _ctx.changeSourceAccount
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, { value: "" }, {
                            default: _withCtx(() => [
                              _hoisted_12
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sourceAccount, (data) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: data.account_number,
                              label: data.account_number + ` - ` + data.account_holder,
                              value: data.account_number
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "loading", "onChange"]),
                      (_ctx.descriptionSourceAccount)
                        ? (_openBlock(), _createBlock("span", _hoisted_13, [
                            _createVNode("b", null, _toDisplayString(_ctx.descriptionSourceAccount), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _hoisted_14,
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        size: "small",
                        modelValue: _ctx.overbooking.destination_account,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.overbooking.destination_account = $event)),
                        loading: _ctx.isValidatingDestination,
                        placeholder: "Please select destination account number",
                        style: {"width":"100%"},
                        onChange: _ctx.changeDestinationAccount
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, { value: "" }, {
                            default: _withCtx(() => [
                              _hoisted_15
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.destinationAccount, (data) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: data.account_number,
                              label: data.account_number + ` - ` + data.account_holder,
                              value: data.account_number
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "loading", "onChange"]),
                      (_ctx.descriptionDestinationAccount)
                        ? (_openBlock(), _createBlock("span", _hoisted_16, [
                            _createVNode("b", null, _toDisplayString(_ctx.descriptionDestinationAccount), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_17, [
                        _createVNode("a", {
                          class: "btn btn-sm btn-link",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.gotoInquiry()))
                        }, " Add Account ")
                      ])
                    ]),
                    _: 1
                  }),
                  _hoisted_18,
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        size: "small",
                        type: "text",
                        placeholder: "Please input amount",
                        onKeypress: _ctx.inputNumbersOnly,
                        modelValue: _ctx.overbooking.amount,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.overbooking.amount = $event)),
                        readonly: ""
                      }, null, 8, ["onKeypress", "modelValue"]),
                      (_ctx.overbooking.amount)
                        ? (_openBlock(), _createBlock("span", _hoisted_19, "Rp. " + _toDisplayString(_ctx.numberFormat(_ctx.overbooking.amount)), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _hoisted_20,
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        size: "small",
                        type: "text",
                        placeholder: "Please input description",
                        modelValue: _ctx.overbooking.description,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.overbooking.description = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createVNode("button", {
                      type: "button",
                      ref: "submitButton",
                      class: "btn btn-primary",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.showDialog && _ctx.showDialog(...args)))
                    }, [
                      _hoisted_23,
                      _hoisted_24
                    ], 512),
                    _createVNode(_component_el_dialog, {
                      modelValue: _ctx.dialogVisible,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.dialogVisible = $event)),
                      title: "Confirmation",
                      width: "30%"
                    }, _createSlots({
                      default: _withCtx(() => [
                        _withDirectives(_createVNode(_component_el_descriptions, {
                          size: "small",
                          column: "1",
                          class: "mb-8",
                          border: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_descriptions_item, { label: "Source Account Number" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.overbooking.source_account), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_descriptions_item, { label: "Source Account Name" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.overbooking.source_account_holder), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_descriptions_item, { label: "Description Source Account" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.descriptionSourceAccount), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_descriptions_item, { label: "Destination Account Number" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.overbooking.destination_account), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_descriptions_item, { label: "Destination Account Name" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.overbooking.destination_account_holder), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_descriptions_item, { label: "Description Destination Account" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.descriptionDestinationAccount), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_descriptions_item, { label: "Amount" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Rp. " + _toDisplayString(_ctx.numberFormat(_ctx.overbooking.amount)) + " ", 1),
                                _hoisted_25,
                                _hoisted_26,
                                _createVNode("i", null, _toDisplayString(_ctx.terbilang(_ctx.overbooking.amount)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_descriptions_item, { label: "Description" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.overbooking.description), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 512), [
                          [_directive_loading, _ctx.inquiryInProcess]
                        ]),
                        (!_ctx.inquiryInProcess)
                          ? (_openBlock(), _createBlock("span", _hoisted_27, "Are you sure you want to submit overbooking?"))
                          : _createCommentVNode("", true),
                        _hoisted_28
                      ]),
                      _: 2
                    }, [
                      (!_ctx.inquiryInProcess)
                        ? {
                            name: "footer",
                            fn: _withCtx(() => [
                              _createVNode("span", _hoisted_29, [
                                _createVNode(_component_el_button, {
                                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.dialogVisible = false))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_30
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  onClick: _ctx.submitOverbooking
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_31
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ])
                            ])
                          }
                        : undefined
                    ]), 1032, ["modelValue"])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ])
    ])
  ]))
}